import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaSimulacros from "./Equipos/CreaModals/CreaSimulacros";
import Cookies from "universal-cookie";

function Titulo23SeccionC(props) {
  const [list, setList] = useState([]);
  const cookies = new Cookies();

  const cargarSimulacros = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerSimulacrosPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((res) => setList(res.data || []))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    cargarSimulacros();
  }, [props.idSolicitud]);

  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            2.3.1 Simulacros realizados en los últimos cuatro años
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
          nombreRuta === "ProcesoAutoevaluacion" ? (
            <CreaSimulacros
              idSolicitud={props.idSolicitud}
              onCreate={cargarSimulacros}
            />
          ) : null}

          <div className="table-responsive mt-3">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Sede</th>
                  <th>Fecha simulacro</th>
                  <th>Tipo simulacro</th>
                  <th>Duración</th>
                </tr>
              </thead>
              <tbody>
                {list.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No hay registros
                    </td>
                  </tr>
                ) : (
                  list.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.sede}</td>
                      <td>{item.fecha_Simulacro}</td>
                      <td>{item.tipo_Simulacro}</td>
                      <td>{item.duracion}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Titulo23SeccionC;
